import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Pip = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 25 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M10 17.093H5.5a2 2 0 0 1-2-2v-8.5a2 2 0 0 1 2-2H18a2 2 0 0 1 2 2v4.5m-5 3.5h5.5a1.5 1.5 0 0 1 1.5 1.5v2.5a1.5 1.5 0 0 1-1.5 1.5H15a1.5 1.5 0 0 1-1.5-1.5v-2.5a1.5 1.5 0 0 1 1.5-1.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <>
        <path
          d='M4.25 6.593c0-.69.559-1.25 1.25-1.25H18c.69 0 1.25.56 1.25 1.25v4.5a.75.75 0 0 0 1.5 0v-4.5A2.75 2.75 0 0 0 18 3.843H5.5a2.75 2.75 0 0 0-2.75 2.75v8.5a2.75 2.75 0 0 0 2.75 2.75H10a.75.75 0 1 0 0-1.5H5.5a1.25 1.25 0 0 1-1.25-1.25z'
          fill='currentColor'
        />
        <path
          d='M15 13.843a2.25 2.25 0 0 0-2.25 2.25v2.5a2.25 2.25 0 0 0 2.25 2.25h5.5a2.25 2.25 0 0 0 2.25-2.25v-2.5a2.25 2.25 0 0 0-2.25-2.25z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
